<template>
  <header class="header">
    <h1 class="header__title no-margin">EBEN HAFKAMP</h1>
    <div class="header__tags">
      <small>Senior Web Developer Résumé</small>
      <small>Last update: 15/10/2025</small>
    </div>
  </header>
</template>

<style scoped lang="scss">
.header {
  padding-block: 3.5rem;
  padding-inline: 2rem;
  position: relative;
  display: flex;
  flex-direction: column-reverse;

  @include mq(--tablet-up) {
    flex-direction: column;
  }

  &__title {
    text-align: center;
    font-family: var(--font-family-header-alt);
    font-size: 5rem;
    line-height: 100%;
    color: var(--white);

    @include mq(--tablet-up) {
      font-size: 8rem;
    }
  }

  &__tags {
    margin-inline: -1rem;
    margin-block: -2.5rem 3rem;
    display: flex;
    justify-content: space-between;
    font-size: 0.75rem;
    font-style: italic;
    font-weight: bold;
    color: var(--light-grey);

    @include mq(--tablet-up) {
      margin-inline: 0;
      margin-block: 0;
      font-size: 0.8rem;
    }
  }
}
</style>
